<template lang="pug">
	
	.amerikkkan-intro

		section-intro(img="assets/images/amerikkkan.jpg" title="All AmeriKKKan Bada$$")

		.amerikkkan-intro-content

			.spotify-module
				a.spotify-link(href="https://www.youtube.com/watch?v=kYgarGQnfJ4" target='blank')
					.module-image
						img(src="assets/images/amerikkkan-thumb.png").thumb
						img(src="assets/images/play-full-icon.png" v-if="!isMobile").play-icon
					
					.module-text
						img(src="assets/images/play-full-icon.png" v-if="isMobile").play-icon
						p {{translate('globals.listen')}}
						p.album-name all - amerikkkan bada$$

			splited-text(ref="splitedText" :text="text")



</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scrollable from '~abstracts/scrollable'
	import SectionIntro from '~components/section-intro.vue'
	import SplitedText from '~components/splited-text.vue'
	import {GlobalMixin} from '~mixins/mixins'
	
  	@Component({
		name: 'PoliticalIntro',
		components: { SectionIntro,SplitedText },
		mixins: [GlobalMixin],
		data : function () {
			return {
				text : ""
			}
		}
	})

	class PoliticalIntro extends Scrollable {

		created () {
			this.text = this.translate('amerikkkan.text')
		}

		mounted () {
			super.mounted()

			

			this._dom()
		}

		init () {
			super.init()

		}


		_dom () {
			
			this.$text = this.$el.querySelector('.text')
			this.$fakeText = this.$el.querySelector('.fake-text')

		}

		initTimeline () {
			super.initTimeline()
			
			this.tl.fromTo(this.fakeAnim,1,{value:0},{value:1, ease: Power0.easeNone},0)
			this.tl.add(()=>{

				if(this.scroller.direction == 1 || this.isResized == false) {
					this.$refs.splitedText.animateIn()
				} else {
					this.$refs.splitedText.animateOut()
				}
				this.isResized = true
			},  window.innerHeight * .7 / (this.bounds.height))
		}

		_bind () {
			super._bind()
		}

		raf (y) {
			super.raf(y)	
		}

		_resize () {
			super._resize()

			this.$refs.splitedText.resize()

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top + this.bounds.height
			}


			this.initTimeline()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
		}

	}

	export default PoliticalIntro

</script>


<style lang="stylus">
	
	@import '../../../theme/utils'
	@import '../../../theme/variables'
	
	.amerikkkan-intro
		width 100%
		// padding-top calc(50vh + 225px)
		position relative
		min-height 100vh
		padding-bottom 250px
		// background-color #0f0d37

		+break(xs)
			padding-bottom 50px

		.amerikkkan-intro-content
			position relative
			width 100%

			+break(xs)
				padding-top 30px

		.splited-text
			width 50vw
			margin auto
			text-align center
			margin-top 0px
			max-width 720px
			position relative
			z-index 80

			+break(minlg)
				max-width 900px

			+break(xs)
				width 100%
				margin-top 8px

		.spotify-module
			position absolute
			top 50px
			left 5%
			z-index 80

			+break(xs)
				position relative
				top 0
				left 0
			

			.spotify-link
				position relative
				display inline-block
				outline none
				text-decoration none
				color #fff
				text-align center

				.module-image
					position relative

				+break(xs)
					display flex
					align-items flex-end

					.module-text
						text-align left
						margin-bottom 12px
						padding-left 10px

				.thumb
					margin-bottom 15px

					+break(xs)
						margin-bottom 0

				.play-icon
					position absolute
					width 42px
					left calc(50% - 21px)
					top 130px

					+break(xs)
						top 0
						left 0
						position relative
						margin-bottom 6px

				p
					font-size 15px
					line-height em(19px,15px)
					font-family $FONT_SECONDARY
					text-transform uppercase
					font-weight 300
					letter-spacing .15em

					&.album-name
						font-weight 700

					

</style>


// WEBPACK FOOTER //
// amerikkkan-intro.vue?9a975508